enum FoodType {
  Vegetarian = 0,
  ContainEgg = 1,
  NonVegetarian = 2,
}

export default FoodType;
